window.addEventListener('DOMContentLoaded', function() {
setTimeout(() => {

function loadScript() {
  // <!-- Nextop LiveChat {literal} -->
  (function(d,w,c){w.NextopLiveChatID='LIVECHAT:1758792152404:783080186013847552';w[c]=w[c]||function(){(w[c].q=w[c].q||[]).push(arguments)};var s=d.createElement('script');s.async=true;s.src='https://livechat.nextop.com/nextop-im-sdk.min.js';if(d.head)d.head.appendChild(s)})(document,window,'NextopLiveChat');
  // <!-- / Nextop LiveChat {/literal} -->

  window.removeEventListener('scroll', loadScript);
}
window.addEventListener('scroll', loadScript);

// <!-- Meta Pixel Code -->
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2914453748735152');
fbq('track', 'PageView');
// <!-- End Meta Pixel Code -->
}, 0);

(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "yvinfr9voh");

})